import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { allFaqs } from '../../utils/pageJsonLd.js';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { FaqItem } from './FaqItem.jsx';
import { useLocalizedPath } from '../../hooks/useLocalizedPath.jsx';
import { INK, PURPLE } from '../sections/theme.js';
import { ArrowIcon } from '../sections/ArrowIcon.jsx';

export default function Faqs({
    seeMore = false,
    titleComponent = 'h2',
    questions,
    showTitle = true,
    namespace = 'home.faqs',
}) {
    const questionComponent = titleComponent === 'h1' ? 'h2' : 'h3';
    const { t } = useTranslation();
    const { faqs } = useLocalizedPath();
    const shownQuestions = questions ?? allFaqs(t);

    return (
        <>
            <Stack sx={{ background: '#fff', pt: { xs: 6, md: 8 }, pb: { xs: 6, md: 8 } }}>
                <Container>
                    <Stack
                        sx={{
                            alignItems: 'center',
                        }}
                    >
                        {showTitle && (
                            <Typography
                                variant={'h2'}
                                component={titleComponent}
                                sx={{
                                    color: INK,
                                    textAlign: 'center',
                                    fontSize: { xs: '1.75rem', md: '2.125rem' },
                                    fontWeight: 700,
                                    letterSpacing: '-0.01em',
                                    mb: 4.5,
                                }}
                            >
                                <Trans i18nKey={'home.faqs.title'} />
                            </Typography>
                        )}
                        <Stack spacing={1.5} sx={{ width: { xs: '100%', md: 860 } }}>
                            {shownQuestions.map((x) => (
                                <FaqItem key={x} idx={x} questionComponent={questionComponent} namespace={namespace} />
                            ))}
                        </Stack>

                        {seeMore && (
                            <Stack
                                component={'a'}
                                href={faqs()}
                                direction="row"
                                sx={{
                                    alignItems: 'center',
                                    gap: 0.75,
                                    mt: 4,
                                    fontSize: '0.9375rem',
                                    fontWeight: 600,
                                    color: PURPLE,
                                    textDecoration: 'none',
                                    '&:hover': { color: '#3F1C84' },
                                }}
                            >
                                <Trans i18nKey={'home.faqs.see_more'} />
                                <ArrowIcon />
                            </Stack>
                        )}
                    </Stack>
                </Container>
            </Stack>
        </>
    );
}
